import background from './background.mjs'
import {
  imgproxySettings,
  mobileImgproxySettings,
  resolvePaceOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Idarkgrey_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Inavy_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Iblack_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/250804/uf_Mmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Mpink_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Ultras/uf/uf_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/uf_Rslateblue_{nnn}.png',
    },
    blackfrost: {
      pathTemplate: 'gs://sg360/260311/uf_Iblackfrost--{nnn}.png',
    },
    desertsand: {
      pathTemplate: 'gs://sg360/260311/uf_Idesertsand--{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/uf_Iglacierblue--{nnn}.png',
    },
  },
}

export const nose = {
  id: 'nose',
  name: 'Nose',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    Fclear: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Fclear_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Fclear_{nnn}.png',
    },
    grey: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Idarkgrey_{nnn}.png',
    },
    navy: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Mnavy_{nnn}.png',
    },
    black: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Mblack_{nnn}.png',
    },
    mint: {
      pathTemplate: 'gs://sg360/250804/un_Rmint_{nnn}.png',
    },
    pink: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Mpink_{nnn}.png',
    },
    stone: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Mstone_{nnn}.png',
    },
    white: {
      pathTemplate: 'gs://sg360/220520/Ultras/un/un_Mwhite_{nnn}.png',
    },
    slateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/un_Rslateblue_{nnn}.png',
    },
    blackfrost: {
      pathTemplate: 'gs://sg360/260311/un_Iblackfrost--{nnn}.png',
    },
    desertsand: {
      pathTemplate: 'gs://sg360/260311/un_Idesertsand--{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/un_Iglacierblue--{nnn}.png',
    },
  },
}

export const earsocks = {
  id: 'earsocks',
  name: 'Earsocks',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Rblue: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rblue_{nnn}.png',
    },
    Rgold: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rgold_{nnn}.png',
    },
    Rgrey: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rgrey_{nnn}.png',
    },
    Rnavy: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rnavy_{nnn}.png',
    },
    Rstone: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rstone_{nnn}.png',
    },
    Rblack: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rblack_{nnn}.png',
    },
    Rmint: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rmint_{nnn}.png',
    },
    Rwhite: {
      pathTemplate: 'gs://sg360/220520/Ultras/ues/ues_Rwhite_{nnn}.png',
    },
    Rslateblue: {
      pathTemplate: 'gs://sg360/240409/slateblue/ues_Rslateblue_{nnn}.png',
    },
    Rdesertsand: {
      pathTemplate: 'gs://sg360/260311/ues_Rdesertsand--{nnn}.png',
    },
    Rglacierblue: {
      pathTemplate: 'gs://sg360/260311/ues_Rglacierblue--{nnn}.png',
    },
  },
}

export const icons = {
  id: 'icons',
  name: 'Icons',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bblack_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bblue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bgold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bgunmetal_{nnn}.png',
    },
    Bpurple: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bpurple_{nnn}.png',
    },
    Bred: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bred_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Brosegold_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bsilver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/220520/Ultras/ui/ui_Bwhite_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    clear: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8clear-{nnn}.png',
    },
    fire: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8fire-{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/260318/ultras/new/gold/ule_8gold-{nnn}.png',
    },
    green: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8green-{nnn}.png',
    },
    hvblue: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8hvblue-{nnn}.png',
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8IRIShvblue-{nnn}.png',
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8IRISsmoke-{nnn}.png',
    },
    purple: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8purple-{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8silverblue-{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8smoke-{nnn}.png',
    },
    chrome4: {
      pathTemplate: 'gs://sg360/260318/ultras/new/ule_8chrome-{nnn}.png',
    },
    a_gold: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8gold-{nnn}.png',
    },
    a_silverblue: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8silverblue-{nnn}.png',
    },
    a_smoke: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8smoke-{nnn}.png',
    },
    a_IRsmoke: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRISsmoke-{nnn}.png',
    },
    a_IRhvblue: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRIShvblue-{nnn}.png',
    },
    a_plum: {
      pathTemplate: 'gs://sg360/260903/ule_a_8plum--{nnn}.png',
    },
    a_IRgold: {
      pathTemplate: 'gs://sg360/260903/ule_a_8IRgold--{nnn}.png',
    },
  },
}

export const reflection = {
  id: 'reflections',
  name: 'Reflections',
  isReflection: true,
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    none: {
      disabled: true,
    },
    r5pc: {
      pathTemplate: 'gs://sg360/220520/Ultras/ule Cloud Overlay/5/ule_Cloud Overlay 5_{nnn}.png',
    },
    r10pc: {
      pathTemplate: 'gs://sg360/220520/Ultras/ule Cloud Overlay/10/ule_Cloud Overlay 10_{nnn}.png',
    },
  },
}

export const iris = {
  id: 'iris',
  name: 'Iris Mask',
  imgproxySettings,
  mobileImgproxySettings,
  isIrisMask: true,
  options: {
    none: {
      disabled: true,
    },
    IRsmoke: {
      pathTemplate: 'gs://sg360/220520/Ultras/ule/ule_Iris Mask_{nnn}.png',
      maxOpacity: 1,
    },
    IRhvblue: {
      pathTemplate: 'gs://sg360/250408/u_hvblue_{nnn}-overlay.png',
      maxOpacity: 0.7,
    },
    a_IRsmoke: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRISsmoke-{nnn}_overlay.png',
    },
    a_IRhvblue: {
      pathTemplate: 'gs://sg360/260318/ultras/air/ule_a_8IRIShvblue-{nnn}_overlay.png',
    },
    a_IRgold: {
      pathTemplate: 'gs://sg360/260903/ule_a_8IRgold--{nnn}-overlay.png',
      maxOpacity: 1,
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/220520/Ultras/ulg/ulg_N_{nnn}.png',
    },
  },
}

function resolveOptions(customisedProduct) {
  const getSKUWithoutPrefix = (sku) => sku?.split('_')?.slice(1)?.join('_')

  return {
    frame: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.frameChoice?.sku)),
    nose: stripMatteOrInfinitePrefix(getSKUWithoutPrefix(customisedProduct.noseChoice?.sku) || 'none'),
    icons: getSKUWithoutPrefix(customisedProduct.iconChoice.sku),
    engraving: 'eN',
    iris: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    earsocks: getSKUWithoutPrefix(customisedProduct.earsocksChoice.sku),
    lens: getSKUWithoutPrefix(customisedProduct.lensChoice.skuWithoutLensTech),
    reflections: 'r5pc',
  }
}

export default {
  supports360: false,
  layers: [background, frame, nose, earsocks, icons, lenses, iris, reflection],
  resolveOptions,
  resolveOptionsFromSKU,
}
